import Axios from "axios";
import {
    SET_SUB_MODULE_LIST,
    UNSET_SUB_MODULE_LIST
  } from "@/store/mutation-types";
// import { saveMsg, updateMsg, deleteMsg, failedMsg } from "@/store/erpUtil";
import { saveUpdateSubModuleSetup, getSubModuleList, deleteSubModule  } from "@/store/api";
// initial state
const state = {
  getSubModuleList: [],
};

const getters = {
  getSubModuleList(state) {
    return state.getSubModuleList;
  },
};
const mutations = {
  [SET_SUB_MODULE_LIST](state, data) {
    state.getSubModuleList = data;
  },
  [UNSET_SUB_MODULE_LIST](state) {
    state.getSubModuleList = [];
  },

};

const actions = {

  saveUpdateSubModuleSetup({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSubModuleSetup, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getSubModuleList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSubModuleList, data)
        .then(function (response) {
          commit('SET_SUB_MODULE_LIST',response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_SUB_MODULE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  deleteSubModule({ state, commit }, data) {
    commit("SET_LOADING", {color: "warning"});
    return new Promise(function (resolve, reject) {
    Axios.post(deleteSubModule, {id:data})
        .then((response) => {
            resolve(response);  
        })
        .catch((error) => {
            reject(error)  
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  }


};

export default {
  state,
  getters,
  actions,
  mutations,
};
